import NavCarousel from '../includes/nav-carousel.js';

export default function(r, sectionDiv, originalData) {
	const pastNewsletters = sectionDiv.find('.newsletters-past');

	sectionDiv.find('.btn-print').on('click', function(e) {
		e.preventDefault();
		window.print();
	});

	NavCarousel.init('.newsletters-past');

	pastNewsletters.on('click', 'a', function(e) {

	});
};
